import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import LoadMoreCard from "@/components/Card/LoadMoreCard";
import ContentHeader from "@/components/ContentHeader";
import Loading from "@/components/Loading";
import SliderCore from "@/components/SliderCore";
import Card from "@/components/Card/index";
import { useDeviceInfoQuery, useCopyrights, useIntersectionObserver } from "@/hooks";
import { SLIDER_MAX_NUM } from "@/lib/constants";
import styles from "@/styles/Slider.module.scss";
import classnames from "classnames";
import { cloneElement, createElement, useCallback, useEffect, useRef, useState, useMemo } from "react"; // 複数行にする場合はslidesPerColumnを指定する

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultSliderOptions = {
  slidesPerView: 2,
  slidesPerGroup: 2,
  breakpoints: {
    500: {
      slidesPerView: 3,
      slidesPerGroup: 3
    },
    800: {
      slidesPerView: 4,
      slidesPerGroup: 4
    },
    1100: {
      slidesPerView: 5,
      slidesPerGroup: 5
    },
    1400: {
      slidesPerView: 6,
      slidesPerGroup: 6
    }
  },
  navigation: true,
  // pagination: { clickable: true },
  // lazy: true,
  freeMode: false
};
var largeCardBreakpoints = {
  breakpoints: {
    500: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },
    800: {
      slidesPerView: 3,
      slidesPerGroup: 3
    },
    1100: {
      slidesPerView: 4,
      slidesPerGroup: 4
    }
  }
};
export default function Slider(_ref) {
  var _items$data, _classnames, _items$data2;

  var header = _ref.header,
      _ref$itemComponent = _ref.itemComponent,
      itemComponent = _ref$itemComponent === void 0 ? Card : _ref$itemComponent,
      loading = _ref.loading,
      error = _ref.error,
      items = _ref.items,
      _ref$largeCard = _ref.largeCard,
      largeCard = _ref$largeCard === void 0 ? false : _ref$largeCard,
      noContent = _ref.noContent,
      className = _ref.className,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  if (error) {
    // TODO: error
    console.log(error);
    return null;
  }

  var sliderRef = useRef();
  var intersect = useIntersectionObserver(sliderRef, {
    root: null,
    rootMargin: "100px",
    threshold: 0.0
  });

  var _useCopyrights = useCopyrights(),
      setCopyrights = _useCopyrights.setCopyrights;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useDeviceInfoQuery.data;

  var deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  var sliderOptions = useMemo(function () {
    if (deviceInfo && deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isMobile) {
      defaultSliderOptions.freeMode = true;
    }

    if (largeCard) {
      return Object.assign({}, defaultSliderOptions, largeCardBreakpoints, options);
    } else {
      return Object.assign({}, defaultSliderOptions, options);
    }
  }, [largeCard, deviceInfo, options]);

  var _useState = useState(null),
      focusIndex = _useState[0],
      setFocusIndex = _useState[1];

  var _useState2 = useState(),
      slidesPerView = _useState2[0],
      setSlidesPreView = _useState2[1];

  var _useState3 = useState(),
      activeIndex = _useState3[0],
      setActiveIndex = _useState3[1];

  var _useState4 = useState(),
      swiperControl = _useState4[0],
      setSwiperControl = _useState4[1];

  var onSwiper = useCallback(function (control) {
    setSwiperControl(control);
  }, []);
  var handleMouseEnter = useCallback(function (e) {
    if (swiperControl && !(swiperControl !== null && swiperControl !== void 0 && swiperControl.destroyed) && !largeCard) {
      var slides = swiperControl.slides;
      var current = e.currentTarget.parentElement;
      var currentIndex = slides.indexOf(current);
      setFocusIndex(currentIndex);
    }
  }, [swiperControl, largeCard]);
  var handleMouseLeave = useCallback(function () {
    setFocusIndex(null);
  }, [swiperControl]);
  useEffect(function () {
    var breakPointHandler = function breakPointHandler() {
      if (swiperControl && !(swiperControl !== null && swiperControl !== void 0 && swiperControl.destroyed)) {
        var _slidesPerView = swiperControl.params.slidesPerView;
        setSlidesPreView(_slidesPerView);
      }
    };

    var activeIndexHandler = function activeIndexHandler() {
      if (swiperControl && !(swiperControl !== null && swiperControl !== void 0 && swiperControl.destroyed)) {
        var _activeIndex = swiperControl.activeIndex;
        setActiveIndex(_activeIndex);
      }
    };

    if (swiperControl) {
      swiperControl.on("breakpoint", breakPointHandler);
      breakPointHandler();
      swiperControl.on("activeIndexChange", activeIndexHandler);
      activeIndexHandler();
    }

    return function () {
      if (swiperControl) {
        swiperControl.off("breakpoint", breakPointHandler);
        swiperControl.off("activeIndexChange", activeIndexHandler);
      }
    };
  }, [swiperControl]);
  useEffect(function () {
    if (items) {
      var copyrights = items.data.map(function (item) {
        return item === null || item === void 0 ? void 0 : item.copyright;
      });
      setCopyrights(copyrights);
    }
  }, [items]);
  var children = useMemo(function () {
    if (!loading && items) {
      var _children = items.data.map(function (item, i) {
        return /*#__PURE__*/_jsx("div", {
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          children: /*#__PURE__*/createElement(itemComponent, {
            item: item,
            index: i,
            focusIndex: focusIndex,
            slidesPerView: slidesPerView,
            activeIndex: activeIndex,
            slider: true,
            intersect: intersect
          })
        }, "item-".concat(i));
      });

      if (items.pageInfo.hasNextPage && header !== null && header !== void 0 && header.link) {
        _children.push( /*#__PURE__*/_jsx("div", {
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          children: /*#__PURE__*/_jsx(LoadMoreCard, {
            index: SLIDER_MAX_NUM,
            focusIndex: focusIndex,
            slidesPerView: slidesPerView,
            activeIndex: activeIndex,
            link: header === null || header === void 0 ? void 0 : header.link
          })
        }, "item-".concat(SLIDER_MAX_NUM)));
      }

      return _children;
    } else {
      return null;
    }
  }, [loading, items, focusIndex, activeIndex, slidesPerView, intersect]);
  var noContentEle;

  if (!loading && (items === null || items === void 0 ? void 0 : (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) === 0) {
    if (noContent) {
      noContentEle = /*#__PURE__*/cloneElement(noContent); // return <div className={styles.slider}>{cloneElement(noContent)}</div>;
    } else {
      return null;
    }
  }

  if (!deviceInfo) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.slider, className, (_classnames = {}, _defineProperty(_classnames, styles.feature, focusIndex != null), _defineProperty(_classnames, styles.largeCard, largeCard), _defineProperty(_classnames, styles.mobile, deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isMobile), _classnames)),
    ref: sliderRef,
    children: [header && /*#__PURE__*/_jsx(ContentHeader, _objectSpread({}, header)), loading && /*#__PURE__*/_jsx(Loading, {}), !loading && (items === null || items === void 0 ? void 0 : (_items$data2 = items.data) === null || _items$data2 === void 0 ? void 0 : _items$data2.length) === 0 && /*#__PURE__*/_jsx(_Fragment, {
      children: noContentEle
    }), !loading && items && /*#__PURE__*/_jsx(SliderCore, {
      sliderOptions: sliderOptions,
      onSwiper: onSwiper,
      children: children
    })]
  });
}